import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button, message, Modal, Select, Input, Tooltip } from "antd";
import { format } from "date-fns";
import AllTransactionTable from "../Component/A l lTransaction";

function LogsTrans() {
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [data, setData] = useState([]);
  const [statusFilterValue, setStatusFilterValue] = useState(null);
  const [dateFilter, setdateFilter] = useState(null);
  const [UsernameFilter, setUsernameFilter] = useState(null);
  const [TransidFilter, setTransidFilter] = useState(null);
  const [viewDetails, setViewDetails] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [exchangeFilter, setExchangeFilter] = useState(null);
  const [tradeTypeFilter, setTradeTypeFilter] = useState(null);
  const [copyTradeIdSearch, setCopyTradeIdSearch] = useState("");

  const ViewTotalLevel = (
    statusFilterValue,
    usernameValue,
    adminValue,
    datefilter,
    exchange,
    tradeType
  ) => {
    const jwt = localStorage.getItem("jwt");
    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,
    };

    if (statusFilterValue !== null && statusFilterValue !== undefined) {
      postData.status = [statusFilterValue];
    }
    if (datefilter !== null && datefilter.length > 0) {
      postData.date = datefilter;
    }
    if (usernameValue !== null && usernameValue !== undefined) {
      if (/^\d+$/.test(usernameValue)) {
        postData.transid = [usernameValue];
      } else {
        postData.username = [usernameValue];
      }
    }

    if (adminValue !== null && adminValue !== undefined) {
      postData.adminname = [adminValue];
    }

    if (exchange !== null && exchange !== undefined) {
      postData.exchange = [exchange];
    }
    if (tradeType !== null && tradeType !== undefined) {
      postData.trade_type = [tradeType];
    }

    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: process.env.REACT_APP_API + "/logs/total_page_logs",
      data: postData,
    })
      .then((res) => {
        setTotalPages(res?.data?.Success);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const ViewLevel = (
    statusFilterValue,
    usernameValue,
    adminValue,
    datefilter,
    exchange,
    tradeType,
    copyTradeId
  ) => {
    const jwt = localStorage.getItem("jwt");
    const postData = {
      jwt: jwt,
      page_no: page,
      page_size: size,
    };

    if (statusFilterValue !== null && statusFilterValue !== undefined) {
      postData.status = [statusFilterValue];
    }
    if (datefilter !== null && datefilter.length > 0) {
      postData.date = datefilter;
    }
    if (usernameValue !== null && usernameValue !== undefined) {
      if (/^\d+$/.test(usernameValue)) {
        postData.transid = [usernameValue];
      } else {
        postData.username = [usernameValue];
      }
    }

    if (adminValue !== null && adminValue !== undefined) {
      postData.adminname = [adminValue];
    }

    if (exchange !== null && exchange !== undefined) {
      postData.exchange = [exchange];
    }
    if (tradeType !== null && tradeType !== undefined) {
      postData.exchange_type = [tradeType];
    }

    if (copyTradeId) {
      postData.bot_id = [copyTradeId]; // Add CopyTradeID filter
    }

    axios({
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      url: process.env.REACT_APP_API + "/logs/logs",
      data: postData,
    })
      .then((res) => {
        if (res?.data?.Success === "No transactions yet!") {
          setData([]);
          message.info("No transactions yet!");
        } else {
          setData(res?.data?.Success);
        }
      })
      .catch((err) => {
        message.error(err);
      });
  };

  const shownKeys = [
    "Serial",
    "DateTime",
    "Trans_ID",
    "Adminname",
    "Username",
    "Action",
  ];
  const showModel = (record) => {
    setSelectedDetails(record);
    setViewDetails(true);
  };

  useEffect(() => {
    ViewTotalLevel(
      statusFilterValue,
      UsernameFilter,
      TransidFilter,
      dateFilter,
      exchangeFilter,
      tradeTypeFilter
    );
    ViewLevel(
      statusFilterValue,
      UsernameFilter,
      TransidFilter,
      dateFilter,
      exchangeFilter,
      tradeTypeFilter,
      copyTradeIdSearch
    );
  }, [
    page,
    size,
    dateFilter,
    statusFilterValue,
    TransidFilter,
    UsernameFilter,
    exchangeFilter,
    tradeTypeFilter,
  ]);

  const handleModalClose = () => {
    setViewDetails(false);
    setSelectedDetails(null);
  };

  const handleExchangeChange = (value) => {
    setExchangeFilter(value);
  };

  const handleTradeTypeChange = (value) => {
    setTradeTypeFilter(value);
  };

  const handleSearch = () => {
    ViewLevel(
      statusFilterValue,
      UsernameFilter,
      TransidFilter,
      dateFilter,
      exchangeFilter,
      tradeTypeFilter,
      copyTradeIdSearch
    );
  };

  const formatError = (error) => {
    if (!error || typeof error !== "string") return "--";
    const length = error.length;
    if (length <= 24) return error;
    return `${error.slice(0, 12)}****${error.slice(-12)}`;
  };

  const columns = [
    {
      title: "Sr.No",
      dataIndex: "Serial",
      key: "Serial",
    },
    {
      title: "Date & Time",
      dataIndex: "Created_At",
      key: "Created_At",
    },
    {
      title: "BotID",
      dataIndex: "CopyTradeID",
      key: "CopyTradeID",
    },
    {
      title: "Exchange",
      dataIndex: "Exchange",
      key: "Exchange",
    },

    {
      title: "Symbol",
      dataIndex: "Symbol",
      key: "Symbol",
    },
    {
      title: "Side",
      dataIndex: "Side",
      key: "Side",
    },
    {
      title: "Position Side",
      dataIndex: "PositionSide",
      key: "PositionSide",
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "Type",
    },
    {
      title: "Quantity",
      dataIndex: "Quantity",
      key: "Quantity",
    },

    {
      title: "Exchange Type",
      dataIndex: "Trade_Type",
      key: "Trade_Type",
    },

    // {
    //   title: "Error Type",
    //   dataIndex: "Error_Type",
    //   key: "Error_Type",
    // },

    {
      title: "Error",
      dataIndex: "Formatted_Error",
      key: "Formatted_Error",
      render: (text, record) => (
        <Tooltip title={record.Error}>
          <span>{text}</span>
        </Tooltip>
      ),
    },

    // {
    //     title: 'More Details',
    //     dataIndex: 'Details',
    //     key: 'Details',
    //     render: (_, record) => (
    //         <Button onClick={() => showModel(record)} className='text-colorSecondaryDark'>
    //             View
    //         </Button>
    //     ),
    // },
  ];

  const dataSource = Array.isArray(data)
    ? data?.map((item, index) => ({
        Serial: index + 1,
        Created_At: item?.Created_at
          ? (() => {
              const date = new Date(item.Created_at);
              const year = date.getFullYear();
              const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
              const day = String(date.getDate()).padStart(2, "0");
              const hours = String(date.getHours()).padStart(2, "0");
              const minutes = String(date.getMinutes()).padStart(2, "0");
              const seconds = String(date.getSeconds()).padStart(2, "0");
              return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            })()
          : "--",
        Trans_ID: item?.Trans_ID || "--",
        Exchange: item?.Exchange || "--",
        Exchange_Type: item?.Error_Type || "--",
        Username: item?.Username || "--",
        Adminname: item?.Adminname || "--",
        symbol: item?.Parameters?.symbol || "--",
        side: item?.Parameters?.side || "--",
        positionSide: item?.Parameters?.positionSide || "--",
        type: item?.Parameters?.type || "--",
        quantity: item?.Parameters?.quantity || "--",
        CopyTradeID: item?.CopyTradeID || "--",
        Error_Type: item?.Error_Type || "--",
        Symbol: item?.Parameters?.Symbol || "--",
        Side: item?.Parameters?.Side || "--",
        PositionSide: item?.Parameters?.PositionSide || "--",
        Type: item?.Parameters?.Type || "--",
        Quantity: item?.Parameters?.Quantity || "--",
        Formatted_Error: formatError(item?.Error),
        ...(item || "--"),
      }))
    : [];

  const prepareDataForCSV = () => {
    const csvData = Array.isArray(data)
      ? data?.map((item, index) => ({
          Serial: index + 1,
          Created_At: item?.Created_at || "--",
          
          Exchange: item?.Exchange || "--",
          Exchange_Type: item?.Error_Type || "--",
         
          CopyTradeID: item?.CopyTradeID || "--",
         
          Symbol: item?.Parameters?.Symbol || "--",
          Side: item?.Parameters?.Side || "--",
          PositionSide: item?.Parameters?.PositionSide || "--",
          Type: item?.Parameters?.Type || "--",
          Quantity: item?.Parameters?.Quantity || "--",
          Error: item?.Error,
          ...(item || "--"),
        }))
      : [];

    return csvData;
  };

  const handleDateChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      const formattedDates = dates
        .map((date) => date.toDate())
        .map((date) => format(date, "dd-MM-yyyy"));
      setdateFilter(formattedDates);
    } else {
      setdateFilter(null);
    }
  };

  return (
    <>
      <div className="mx-4 bg-white shadow-md shadow-black rounded-xl p-4">

        <Input
          value={copyTradeIdSearch}
          onChange={(e) =>
            setCopyTradeIdSearch(e.target.value.replace(/\s+/g, ""))
          }
          placeholder="Search CopyTradeID"
          style={{ width: 200, marginRight: 10 }}
        />
        <Button onClick={handleSearch} type="" style={{ marginRight: 10 }}>
          Search
        </Button>



        <label htmlFor="">Exchange :</label>
        <Select
          value={exchangeFilter}
          onChange={handleExchangeChange}
          placeholder="Select Exchange"
          style={{ width: 150, marginRight: 10 }}
        >
          <Select.Option value="BINANCE">BINANCE</Select.Option>
          <Select.Option value="KUCOIN">KUCOIN</Select.Option>
          {/* Add more options as needed */}
        </Select>
        


        <label htmlFor="">Type :</label>
        <Select
          value={tradeTypeFilter}
          onChange={handleTradeTypeChange}
          placeholder="Select Trade Type"
          style={{ width: 100 }}
        >
          <Select.Option value="FUTURES">FUTURES</Select.Option>
          <Select.Option value="SPOT">SPOT</Select.Option>
          {/* Add more options as needed */}
        </Select>


        <AllTransactionTable
          data={data}
          handleDateChange={handleDateChange}
          prepareDataForCSV={prepareDataForCSV}
          setData={setData}
          columns={columns}
          dataSource={dataSource}
          totalPages={totalPages}
          page={page}
          size={size}
          setPage={setPage}
          setSize={setSize}
        />
        
      </div>
      <Modal
        title="Transaction Details"
        className="border border-colorSecondaryDark rounded-lg shadow-md shadow-black bg-white"
        visible={viewDetails}
        onCancel={handleModalClose}
        footer={[
          <Button key="close" onClick={handleModalClose}>
            Close
          </Button>,
        ]}
      >
        {selectedDetails && (
          <>
            <div className="p-2 border border-colorSecondaryDark rounded-lg my-2">
              {selectedDetails.Parameters &&
                Object.entries(selectedDetails.Parameters)
                  .filter(([key]) => !shownKeys.includes(key))
                  .map(([key, value]) => {
                    let displayValue = value;
                    if (key === "Side") {
                      displayValue = value === "0" ? "Left" : "Right";
                    }
                    return (
                      <div key={key} className="grid grid-cols-2 gap-4">
                        <p>
                          <strong>{key}:</strong> {displayValue?.toString()}
                        </p>
                      </div>
                    );
                  })}
            </div>

            {/* Display CopyTrade_Id */}
            <div className="p-2 border border-colorSecondaryDark rounded-lg">
              {selectedDetails.CopyTrade_Id && (
                <div>
                  <strong>CopyTrade ID:</strong> {selectedDetails.CopyTrade_Id}
                </div>
              )}

              {/* Display Error_Type */}
              {selectedDetails.Error_Type && (
                <div>
                  <strong>Error Type:</strong> {selectedDetails.Error_Type}
                </div>
              )}

              {/* Display Error */}
              {selectedDetails.Error && (
                <div>
                  <strong>Error:</strong> {selectedDetails.Error}
                </div>
              )}
            </div>
          </>
        )}
      </Modal>
    </>
  );
}

export default LogsTrans;
